<template>
  <footer class="bg-white">
    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
      <div class="border-t border-gray-200 py-8 text-sm text-gray-500 text-center sm:text-left space-x-4">
        <span class="block sm:inline">
          &copy; 2024 Shelfd UG
        </span>
        <span>
          <a href="/blog" target="_blank">
            Neues im Blog
          </a>
        </span>
        <span>
          <a href="/newsletter" target="_blank">
            Newsletter
          </a>
        </span>
        <span>
          <a href="/privacy" target="_blank">
            Datenschutz
          </a>
        </span>
        <span>
          <a href="/terms" target="_blank">
            AGB
          </a>
        </span>
        <span>
          <a href="/imprint" target="_blank">
            Impressum
          </a>
        </span>
        <span class="block sm:inline">
          ♥ Gefördert durch das MIZ-Babelsberg und die Medienanstalt NRW
        </span>
      </div>
    </div>
  </footer>
</template>
